/**
 * IconButton — now delegates to the shared CircleIconButton with size=80.
 * Kept as a re-export for backward compatibility.
 */
import CircleIconButton, { type CircleIconButtonProps } from "../CircleIconButton";

export function IconButton(props: CircleIconButtonProps & { onRef?: (el: any) => void }) {
  return (
    <CircleIconButton
      {...props}
      size={80}
      ref={props.onRef}
    />
  );
}
